module.exports = __webpack_public_path__ + "static/Messaging 1-2293633e3137c6bcfda9d952e5cc2eba.png";